import { render, staticRenderFns } from "./CreateCampaignButton.vue?vue&type=template&id=19818936&"
import script from "./CreateCampaignButton.vue?vue&type=script&lang=js&"
export * from "./CreateCampaignButton.vue?vue&type=script&lang=js&"
import style0 from "./CreateCampaignButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports